var render = function render(){var _vm=this,_c=_vm._self._c;return _c('review-component',_vm._g(_vm._b({},'review-component',_vm.$props,false),_vm.$listeners),[_vm._v(" <button>"+_vm._s(_vm.tr(_vm.component.text))+"</button> "),(_vm.component.link)?[_vm._v(" <a href=\""+_vm._s(_vm.component.link.to || _vm.component.link.href)+"\"/> ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }